var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSweatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.892 7.477a.692.692 0 00-.692.692v3.461H4.57a.692.692 0 00-.693.693v3.461h-2.63a.692.692 0 00-.693.693V19.8c0 .382.31.692.692.692h2.63v3.461c0 .383.31.693.693.693H7.2v3.461c0 .383.31.693.692.693h3.323c.383 0 .693-.31.693-.693v-7.615h11.907v7.615c0 .383.31.693.693.693h3.323c.382 0 .692-.31.692-.693v-3.461h2.63c.383 0 .693-.31.693-.693v-3.461h2.63c.383 0 .693-.31.693-.692v-3.323a.692.692 0 00-.692-.693h-2.63v-3.461a.692.692 0 00-.693-.693h-2.63V8.17a.692.692 0 00-.693-.692h-3.323a.692.692 0 00-.693.692v7.615H11.908V8.17a.692.692 0 00-.693-.692H7.892zm-4.015 11.63V17.17H1.938v1.938h1.939zm1.385 4.154H7.2V13.015H5.262v10.246zm25.2 0h-1.939V13.015h1.939v10.246zm3.323-4.154h-1.939V17.17h1.939v1.938zm-25.2 8.308h1.938V8.861H8.585v18.554zm18.553 0H25.2V8.861h1.938v18.554zm-15.23-10.246v1.938h11.907V17.17H11.908z",
    fill: "#04B7D6"
  })));
}

export default SvgSweatIcon;